import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Department } from './department';
 import { environment } from '../environments/environment';
const httpOptions = {
  headers: new HttpHeaders({ 'Content-Type': 'application/json' })
};
 
@Injectable({
  providedIn: 'root'
})
export class DepartmentService {
  
    baseUrl = environment.baseUrl;
    private departmentUrl = this.baseUrl + '/api/department';  // URL to web api
	 private getDepartmentByHeadURL = this.baseUrl + '/api/department/GetDepartmentByHead';  // URL to web api

  constructor( 
    private http: HttpClient
  ) { }

  getDepartments (): Observable<Department[]> {
    return this.http.get<Department[]>(this.departmentUrl)
  }
  getDepartment(deptid: number): Observable<Department> {
    const url = `${this.departmentUrl}/${deptid}`;
    return this.http.get<Department>(url);
  }
  
  GetDepartmentByHead(DeptHeadID: number): Observable<Department> {
    const url = `${this.getDepartmentByHeadURL}/${DeptHeadID}`;
    return this.http.get<Department>(url);
  }
  
  addDepartment (department: Department): Observable<Department> {
    return this.http.post<Department>(this.departmentUrl, department, httpOptions);
  }
 
  deleteDepartment (department: Department | number): Observable<Department> {
    const deptid = typeof department === 'number' ? department : department.deptid;
    const url = `${this.departmentUrl}/${deptid}`;
 
    return this.http.delete<Department>(url, httpOptions);
  }
 
  updateDepartment (department: Department): Observable<any> {
    return this.http.put(this.departmentUrl, department, httpOptions);
  }

  getrequester (): Observable<Department[]> {
    return this.http.get<Department[]>(this.baseUrl +'/api/requester')
  }
 
}